import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { adminApi } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { fmtDate, fmtNum, StatusPill, Panel, PageHeader, Th, Td, Empty } from "@/components/admin/parts";

const FILTERS = [
  { key: "all", label: "Wszystkie" },
  { key: "settled", label: "Wykonane" },
  { key: "failed", label: "Nieudane" },
];

export default function AiOperations() {
  const [params] = useSearchParams();
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState(params.get("status") || "all");

  useEffect(() => {
    adminApi.aiOperations({ status: filter, limit: 100 }).then(setData).catch(() => {});
  }, [filter]);

  return (
    <div>
      <PageHeader title="Operacje AI" subtitle="Rejestr operacji (bez treści użytkownika)" />
      <div className="mb-4 flex flex-wrap gap-2">
        {FILTERS.map((f) => (
          <button key={f.key} onClick={() => setFilter(f.key)} className={`rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${filter === f.key ? "bg-brand-accent text-brand-on" : "border border-brand-line text-brand-sec hover:text-brand-text"}`}>{f.label}</button>
        ))}
      </div>
      <Panel testId={ADMIN.aiTable}>
        {!data ? <Empty>Ładowanie…</Empty> : data.items.length === 0 ? <Empty>Brak operacji.</Empty> : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[820px]">
              <thead><tr className="border-b border-brand-line">
                <Th>Data</Th><Th>Użytkownik</Th><Th>Akcja</Th><Th>Model</Th><Th className="text-right">Kredyty</Th><Th className="text-right">Czas</Th><Th>Status</Th>
              </tr></thead>
              <tbody>
                {data.items.map((a) => (
                  <tr key={a.id} className="border-b border-brand-line/60">
                    <Td className="whitespace-nowrap text-brand-sec">{fmtDate(a.created_at)}</Td>
                    <Td className="text-brand-sec">{a.user_email}</Td>
                    <Td>{a.action_key}</Td>
                    <Td className="text-brand-sec">{a.model}</Td>
                    <Td className="text-right">{a.status === "settled" ? <span className="text-brand-sec">-{a.credits_charged}</span> : <span className="text-amber-300">zwrot +{a.credits_refunded}</span>}</Td>
                    <Td className="text-right text-brand-sec">{a.duration_ms ? `${a.duration_ms} ms` : "—"}</Td>
                    <Td><StatusPill status={a.status === "settled" ? "settled" : "failed"} label={a.status === "settled" ? "WYKONANE" : (a.error_code || "BŁĄD")} /></Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
